import { useWhitelabel } from "hooks";
import React from 'react'
import { BsCreditCard, BsQrCode } from "react-icons/bs"
import { EnumFormaPagamento } from "services"
import styled from "styled-components"

interface MethodSelectorOptionProps {
  methodSelected: EnumFormaPagamento;
  onChange: (method: EnumFormaPagamento) => void;
}

const MethodSelectorOption = ({ methodSelected, onChange }: MethodSelectorOptionProps) => {
  const { client } = useWhitelabel();
  const [showMethodSelector, setShowMethodSelector] = React.useState(false)
  const ref = React.useRef<HTMLDivElement>(null)

  const paymentMethods = [
    { id: EnumFormaPagamento.CREDITO, label: "Cartão de crédito", icon: BsCreditCard, visible: client ? client?.credit_card_enable : true },
    { id: EnumFormaPagamento.DEBITO, label: "Cartão de débito", icon: BsCreditCard, visible: client ? client?.debit_card_enable : true },
    { id: EnumFormaPagamento.PIX, label: "Pix", icon: BsQrCode, visible: client ? client?.pix_enable : true },
  ]

  const handleMethodChange = (method: EnumFormaPagamento) => {
    onChange(method)
    setShowMethodSelector(false)
  }

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setShowMethodSelector(false)
      }
    }

    if (showMethodSelector) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showMethodSelector])

  return (
    <MethodSelector ref={ref}>
      <MethodButton onClick={() => setShowMethodSelector(!showMethodSelector)}>Alterar método</MethodButton>
      {showMethodSelector && (
        <MethodDropdown>
          {paymentMethods.filter(payment => payment.visible).map((method) => {
            const IconComponent = method.icon
            return (
              <MethodOption
                key={method.id}
                onClick={() => handleMethodChange(method.id)}
                isSelected={method.id === methodSelected}
              >
                <IconComponent size={16} />
                {method.label}
              </MethodOption>
            )
          })}
        </MethodDropdown>
      )}
    </MethodSelector>
  )
}

const MethodSelector = styled.div`
  position: relative;
`

const MethodButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: #333;
  }
`

const MethodDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 180px;
  margin-top: 4px;
`

const MethodOption = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  background: ${(props) => (props.isSelected ? "#f0f0f0" : "white")};
  
  &:hover {
    background: #f8f9fa;
  }

  &:first-child {
    border-radius: 6px 6px 0 0;
  }

  &:last-child {
    border-radius: 0 0 6px 6px;
  }
`

export default MethodSelectorOption